@if (tracedMaterials$ | async; as materials) {
  <div class="layout-col full bg-background">
    <app-batch-tracing-conf-browser class="flex" [tracedMaterials]="materials" (close)="close()">
    </app-batch-tracing-conf-browser>
  </div>
}
